var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabs" }, [
    _c("div", { staticClass: "tabs-bar" }, [
      _c("div", { staticClass: "tabs-nav-container" }, [
        _c(
          "div",
          {
            ref: "navWrap",
            staticClass: "tabs-nav-wrap",
            class: [_vm.scrollable ? "tabs-nav-scrollable" : ""]
          },
          [
            _c(
              "span",
              {
                staticClass: "tabs-nav-prev",
                class: [_vm.scrollable ? "" : "tabs-nav-scroll-disabled"],
                on: { click: _vm.scrollPrev }
              },
              [_c("i", { staticClass: "am-icon am-icon-ios-arrow-back" })]
            ),
            _c(
              "span",
              {
                staticClass: "tabs-nav-next",
                class: [_vm.scrollable ? "" : "tabs-nav-scroll-disabled"],
                on: { click: _vm.scrollNext }
              },
              [_c("i", { staticClass: "am-icon am-icon-ios-arrow-forward" })]
            ),
            _c("div", { ref: "navScroll", staticClass: "tabs-nav-scroll" }, [
              _c(
                "div",
                {
                  ref: "nav",
                  staticClass: "tabs-nav am-cf",
                  style: _vm.navStyle
                },
                [
                  _c("div", {
                    staticClass: "tabs-link-bar",
                    style: _vm.barStyle
                  }),
                  _vm._l(_vm.navList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tabs-tab",
                        on: {
                          click: function($event) {
                            return _vm.handleChange(index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.label))]
                    )
                  })
                ],
                2
              )
            ])
          ]
        )
      ])
    ]),
    _c(
      "div",
      {
        ref: "panes",
        staticClass: "tabs-content tab-content-animated",
        style: _vm.contentStyle
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5553b944", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5553b944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Tabs/Tabs.vue
// module id = mdak
// module chunks = 3